// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2ppRB","addWidgetButton":"Header_addWidgetButton__37fxG","dashboardTabs":"Header_dashboardTabs__fTUcj","active":"Header_active__2HqMV"};